import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Vision.css';

const Vision = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: window.innerWidth <= 768 ? 0.05 : 0.3,
        rootMargin: '30px'
      }
    );

    const section = document.getElementById('vision');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  const focusAreas = [
    {
      title: t('vision.focusAreas.vfx.title'),
      description: t('vision.focusAreas.vfx.description'),
      icon: '🎨',
      color: 'yellow'
    },
    {
      title: t('vision.focusAreas.unreal.title'),
      description: t('vision.focusAreas.unreal.description'),
      icon: '⚙️',
      color: 'teal'
    },
    {
      title: t('vision.focusAreas.ai.title'),
      description: t('vision.focusAreas.ai.description'),
      icon: '🤖',
      color: 'blue'
    },
    {
      title: t('vision.focusAreas.web.title'),
      description: t('vision.focusAreas.web.description'),
      icon: '💻',
      color: 'violet'
    }
  ];

  return (
    <section id="vision" className="vision section">
      <div className="container">
        <div className={`vision-content ${isVisible ? 'visible' : ''}`}>
          <h2 className="vision-title fade-in-up">
            {t('vision.title')}
          </h2>

          <div className="vision-description fade-in-up">
            <p dangerouslySetInnerHTML={{ __html: t('vision.description') }}>
            </p>
          </div>

          <div className="focus-areas">
            {focusAreas.map((area, index) => (
              <div
                key={index}
                className={`focus-card slide-in-left ${isVisible ? 'visible' : ''} ${area.color}`}
                style={{ animationDelay: `${0.3 + index * 0.2}s` }}
              >
                <div className="focus-icon">
                  <span className="icon-emoji">{area.icon}</span>
                </div>
                <h3 className="focus-title">{area.title}</h3>
                <p className="focus-description">{area.description}</p>
              </div>
            ))}
          </div>

          <div className="vision-highlight fade-in-up">
            <p className="highlight-text" dangerouslySetInnerHTML={{ __html: t('vision.ownProject') }}>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;